import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=be39d448&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=be39d448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be39d448",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JoinUs: require('/opt/build/repo/components/JoinUs.vue').default,Layout: require('/opt/build/repo/components/Layout.vue').default})
